import moment from 'moment';

const format = {
  date: value => value ? moment(value).format('DD/MM/YYYY') : '',
  bool: value => (value === 1) ? 'כן' : 'לא',
  number: value => value,
  reversSign: value => {
    if (value) {
      if (value.startsWith('-')) {
        return value.split("").reverse().join("");
      }
      else return value
    }
  },
  priceIntegerDivided: value => value ? parseInt(value).toLocaleString() : ''
};

export default format;
